import React from "react";
import { commsStates } from "utils/commsLogStates";

const StateBadge = ({ state }) => {
  const meta = commsStates[state];
  if (!meta) return <span className="text-xs text-darkgray">—</span>;

  return (
    <span
      title={meta.hint}
      className={`inline-block whitespace-nowrap rounded-full px-2.5 py-1 text-xs font-medium ${meta.className}`}
    >
      {meta.label}
    </span>
  );
};

export default StateBadge;
